module.exports = __webpack_public_path__ + "img/logo-temac.1436e8b3.png";